const OWNER_KEY = 'rb_intake_owner'
const SERVER_KEYS = ['rb_screening_session', 'rb_intake_match', 'rb_portal_last_assessment', 'rb_portal_active_session']
const DRAFT_KEYS = ['rb_intake', 'rb_intake_pending']

// Used only to separate local drafts. The backend remains the authentication authority.
export function intakeUserId(token) {
  try {
    const part = String(token || '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const payload = JSON.parse(atob(part.padEnd(Math.ceil(part.length / 4) * 4, '=')))
    return payload.userId == null ? null : String(payload.userId)
  } catch (e) { return null }
}

export function clearIntakeAccountState() {
  SERVER_KEYS.concat(DRAFT_KEYS, OWNER_KEY).forEach(key => sessionStorage.removeItem(key))
}

export function syncIntakeAccount(token) {
  const next = intakeUserId(token)
  let previous = sessionStorage.getItem(OWNER_KEY)
  if (!previous) {
    try {
      const stored = JSON.parse(localStorage.getItem('profile'))
      const profile = stored && (stored.data || stored)
      if (profile && profile.id != null) previous = String(profile.id)
    } catch (e) { /* no cached identity */ }
  }
  const changed = !!previous && previous !== next
  if (changed) {
    clearIntakeAccountState()
    localStorage.removeItem('profile')
  } else if (!previous) {
    // Anonymous draft answers can become the first account's draft. Unknown
    // server snapshots and receipts can never be transferred to a new account.
    SERVER_KEYS.forEach(key => sessionStorage.removeItem(key))
  }
  if (next) sessionStorage.setItem(OWNER_KEY, next)
  else sessionStorage.removeItem(OWNER_KEY)
  return changed
}
